import { camelizeKeys } from 'humps';
import { Cart } from '../interfaces';

const cartItemsMock = [
  {
    thumbnail:
      'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-1.png',
    name: 'Liquid Magic Elixir Double Cask 12 Years Old',
    sizeFulfilled: '1L, bottle - Fulfilled by SpinYard Liquors',
    volume: '1L',
    delivery_expectation: 'Delivery under an hour',
    delivery_method: 'onDemand',
    retailer_name: 'On The Rocks Wine & Liquors',
  },
  {
    thumbnail:
      'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-2.jpg',
    name: 'Liquid Magic Elixir Double Cask 12 Years Old',
    sizeFulfilled: '750ml, bottle - Fulfilled by Coasters DC',
    volume: '750ml',
    delivery_expectation: '1-2 days',
    delivery_method: 'shipped',
    retailer_name: 'DC Wine and Spirits',
  },
  {
    thumbnail:
      'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/Liquid-Bottle-3.jpg',
    name: 'Liquid Magic Elixir Double Cask 12 Years Old',
    sizeFulfilled: '375ml, bottle - Fulfilled by Coasters DC',
    volume: '375ml',
    delivery_expectation: '10 days',
    delivery_method: 'shipped',
    retailer_name: 'DC Wine and Spirits',
    options: {
      type: 2,
      line1: 'Enjoy it',
    },
  },
].map((item, index) => ({
  identifier: Math.floor(Math.random() * (999999 - 90000 + 1) + 90000),
  quantity: 1,
  product: {
    id: 19418081 + index,
    price: '157.0',
    original_price: 157.0,
    in_stock: 4,
    container_type: 'BOTTLE',
    subgroup_id: 'BOTTLE',
    volume: item.volume,
    short_pack_size: '',
    short_volume: item.volume,
    thumb_url: item.thumbnail,
    image_url: item.thumbnail,
    permalink: 'liquid-magic-elixir-double-cask-12-years-old',
    supplier_id: 10155,
    product_id: 2323945,
    deals: [],
    two_for_one: null,
    upc: '120660230668',
    overridable: false,
    sku: '1923692',
    custom_promo: null,
    product_permalink: '',
    pre_sale_expectation: null,
    weight: null,
    engraving_location: 'Below the Label',
  },
  product_grouping: {
    id: Math.floor(Math.random() * (999999 - 90000 + 1) + 90000),
    name: item.name,
    product_name: item.name,
    description:
      'The first ever Double Cask 15 Year Old is the perfect marriage of classic Macallan style and unmistakable sweetness of American Oak aged in hand crafted Sherry Seasoned European and American Oak. The oak casks make the greatest contribution to quality, natural color, & flavor.',
    tags: [],
    type: 'scotch',
    category: 'liquor',
    brand: 'Liquid',
    hierarchy_category: {
      permalink: 'liquor',
      name: 'liquor',
    },
    hierarchy_type: {
      permalink: 'liquor-scotch',
      name: 'scotch',
    },
    hierarchy_subtype: {
      permalink: null,
      name: null,
    },
    brand_data: {
      permalink: 'liquid',
      name: 'Liquid',
    },
    thumb_url: item.thumbnail,
    image_url: item.thumbnail,
    properties: [],
    permalink: 'liquid-magic-elixir-double-cask-12-years-old',
    product_content: false,
    variants: [
      {
        id: 19418084,
        price: '157.0',
        original_price: 157.0,
        in_stock: 4,
        container_type: 'BOTTLE',
        subgroup_id: 'BOTTLE',
        volume: item.volume,
        short_pack_size: '',
        short_volume: item.volume,
        thumb_url: item.thumbnail,
        image_url: item.thumbnail,
        permalink: 'liquid-magic-elixir-double-cask-12-years-old',
        supplier_id: 10155,
        product_id: 2323945,
        deals: [],
        two_for_one: null,
        upc: '120660230668',
        overridable: false,
        sku: '1923692',
        custom_promo: null,
        product_permalink: '',
        pre_sale_expectation: null,
        weight: null,
        engraving_location: 'Below the Label',
      },
      {
        id: 19850990,
        price: 188.99,
        original_price: 188.99,
        in_stock: 1,
        container_type: 'BOTTLE',
        subgroup_id: 'BOTTLE',
        volume: item.volume,
        short_pack_size: '',
        short_volume: item.volume,
        thumb_url: item.thumbnail,
        image_url: item.thumbnail,
        permalink: 'liquid-magic-elixir-double-cask-12-years-old',
        supplier_id: 10155,
        product_id: 2323945,
        deals: [],
        two_for_one: null,
        upc: '120660230668',
        overridable: false,
        sku: '192369210000100750',
        custom_promo: null,
        product_permalink: '',
        pre_sale_expectation: null,
        weight: null,
        engraving_location: 'Below the Label',
      },
    ],
    external_products: [],
    supplier_id: 10155,
    deals: [],
    browse_type: 'INTERNAL',
    product_grouping_permalink: '',
  },
  item_options: item.options,
  deliveryExpectation: item.delivery_expectation,
  deliveryMethod: item.delivery_method,
  retailerName: item.retailer_name,
  bundle: null,
  product_bundle: null,
  customer_placement: 'standard',
  engraving_configs: {
    active: true,
    characters: 16,
    lines: 3,
    location: ['Back of the Bottle'],
  },
}));

const cartTraitMock = {
  coupon_code: null,
  gtm_visitor_id: null,
  gift_order: false,
  age_verified: false,
  decision_log_uuids: {},
  membership_plan_id: null,
};

export function cartMockStandard(id: number, options: any): Cart {
  const cart = {
    id,
    cartItems: [...cartItemsMock],
    cartTrait: { ...cartTraitMock },
  } as any as Cart;
  options.body?.cartItems?.forEach((item) => {
    const cartItem = cart.cartItems.find((i) => i.product.id === item.variantId);
    if (cartItem) {
      cartItem.quantity = item.quantity;
      cartItem.itemOptions = item.options;
    }
  });
  return cart;
}

export function cartMockBundle(id: number, options: any): Cart {
  const cart = camelizeKeys({
    id,
    cart_items: [
      {
        identifier: 1554548469,
        quantity: 1,
        product: {
          id: 4160844,
          price: 64.99,
          original_price: 64.99,
          in_stock: 6,
          container_type: 'BOTTLE',
          subgroup_id: 'BOTTLE',
          volume: '750ml',
          short_pack_size: '',
          short_volume: '750ml',
          thumb_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
          image_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
          permalink: 'old-forester-1920-prohibition-style-whisky-750ml',
          supplier_id: 410,
          product_id: 166020,
          deals: [],
          two_for_one: null,
          upc: '811280011552',
          overridable: false,
          sku: '23921',
          custom_promo: null,
          product_permalink:
            'https://staging.minibardelivery.com/store/product/old-forester-1897-100-proof/old-forester-1920-prohibition-style-whisky-750ml',
          pre_sale_expectation: null,
          weight: null,
          engraving_location: 'Above the Label',
        },
        product_grouping: {
          id: 114046,
          name: 'The Liquid Magic Elixir Blue Finest in Town',
          product_name: 'The Liquid Magic Elixir Blue Finest in Town',
          description:
            'The Volstead Act of 1920 which initiated Prohibition in the USA granted permits to six distillers in Kentucky to continue to bottle bourbon for medicinal purposes. Through one of these permits, Old Forester continued to be produced as medicinal whiskey on Louisville’s famed Whiskey Row. It is the only bourbon continuously sold by the same company that has been available for sale before, during and after Prohibition.\r\n\r\nDuring this time, all whiskies had to be bottled at 100 Proof. With a barrel entry proof of 100, the “angel’s share” would have created a 115 proof whiskey after maturation. To pay homage to this era, Old Forester presents 1920 Prohibition Style Bourbon at 115 proof to represent the rich flavor profile this bourbon had nearly 100 years ago.',
          tags: [],
          type: 'whiskey',
          category: 'liquor',
          brand: 'Liquid',
          hierarchy_category: { permalink: 'liquor', name: 'liquor' },
          hierarchy_type: { permalink: 'liquor-whiskey', name: 'whiskey' },
          hierarchy_subtype: { permalink: null, name: null },
          brand_data: { permalink: 'old-forester', name: 'Old Forester' },
          thumb_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-1.png',
          image_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-1.png',
          properties: [
            { name: 'Alcohol %', value: '115 Proof' },
            { name: 'Region', value: 'Kentucky' },
            { name: 'Country', value: 'United States' },
            { name: 'Year', value: '1995' },
            { name: 'Appellation', value: 'Shively Kentucky' },
            { name: 'Varietal', value: 'Bourbon' },
          ],
          permalink: 'old-forester-1897-100-proof',
          product_content: false,
          variants: [
            {
              id: 4160844,
              price: 64.99,
              original_price: 64.99,
              in_stock: 6,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '750ml',
              short_pack_size: '',
              short_volume: '750ml',
              thumb_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              image_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              permalink: 'old-forester-1920-prohibition-style-whisky-750ml',
              supplier_id: 410,
              product_id: 166020,
              deals: [],
              two_for_one: null,
              upc: '811280011552',
              overridable: false,
              sku: '23921',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/old-forester-1897-100-proof/old-forester-1920-prohibition-style-whisky-750ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: 'Above the Label',
            },
          ],
          external_products: [],
          supplier_id: 410,
          deals: [],
          browse_type: 'INTERNAL',
          product_grouping_permalink:
            'https://staging.minibardelivery.com/store/product/old-forester-1897-100-proof',
        },
        item_options: null,
        bundle: null,
        product_bundle: {
          id: 's-44658dfc-93b2-4280-80ea-a8a6c318432b',
          title: 'The Liquid Magic Elixir Finest in Town 3 Bottle Bundle Collection',
          image:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-1.png',
          component_product_data: [
            { quantity: 1, product_id: '41110' },
            { quantity: 1, product_id: '28525' },
            { quantity: 1, product_id: '207157' },
            { quantity: 1, product_id: '166020' },
          ],
          external_id: 'BUNDLE-200000041',
        },
        customer_placement: 'standard',
        supplier_name: 'Wine Cellar',
        delivery_method: 'shipped',
        delivery_expectation: 'Usually ships within 1-2 business days',
        engraving_configs: {
          active: true,
          characters: 16,
          lines: 1,
          location: ['Above the Label'],
        },
      },
      {
        identifier: 305273693,
        quantity: 1,
        product: {
          id: 1946959,
          price: 79.99,
          original_price: 79.99,
          in_stock: 24,
          container_type: 'BOTTLE',
          subgroup_id: 'BOTTLE',
          volume: '750ml',
          short_pack_size: '',
          short_volume: '750ml',
          thumb_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-3.png',
          image_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-3.png',
          permalink: 'jack-daniel-s-single-barrel-select-whiskey-750ml-079f6',
          supplier_id: 410,
          product_id: 207157,
          deals: [],
          two_for_one: null,
          upc: '082184087008',
          overridable: false,
          sku: '11133',
          custom_promo: null,
          product_permalink:
            'https://staging.minibardelivery.com/store/product/jack-daniel-s-single-barrel/jack-daniel-s-single-barrel-select-whiskey-750ml-079f6',
          pre_sale_expectation: null,
          weight: null,
          engraving_location: 'Side of the Bottle',
        },
        product_grouping: {
          id: 35600,
          name: 'The Liquid Magic Elixir Red Finest in Town',
          product_name: 'The Liquid Magic Elixir Red Finest in Town',
          description:
            'Single Barrel is matured in the highest reaches of our barrelhouse, where the dramatic changes in temperature cause its color and taste to deepen further. We still hand select each barrel for its robust taste and notes of toasted oak, vanilla and caramel. The 94 proof whiskey is drawn from individual barrels, offering the opportunity to taste the subtle differences in nose, color and flavor from barrel to barrel.',
          tags: ['whiskey-worth-knowing'],
          type: 'whiskey',
          category: 'liquor',
          brand: "Jack Daniel's",
          hierarchy_category: { permalink: 'liquor', name: 'liquor' },
          hierarchy_type: { permalink: 'liquor-whiskey', name: 'whiskey' },
          hierarchy_subtype: { permalink: 'liquor-whiskey-bourbon', name: 'bourbon' },
          brand_data: { permalink: 'jack-daniel-s', name: "Jack Daniel's" },
          thumb_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-3.png',
          image_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-3.png',
          properties: [
            { name: 'Alcohol %', value: '47' },
            { name: 'Region', value: 'Tennessee' },
            { name: 'Country', value: 'United States' },
            { name: 'Appellation', value: 'Lynchburg Tennessee' },
            { name: 'Varietal', value: 'Bourbon' },
          ],
          permalink: 'jack-daniel-s-single-barrel',
          product_content: false,
          variants: [
            {
              id: 1946959,
              price: 79.99,
              original_price: 79.99,
              in_stock: 24,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '750ml',
              short_pack_size: '',
              short_volume: '750ml',
              thumb_url:
                'https://images.liquidcheckout.com/image/upload/s--nq0UIX9o--/618c1b9975cad08136d7d1ba0ef15b62de05b18b.jpg',
              image_url:
                'https://images.liquidcheckout.com/image/upload/s--nq0UIX9o--/618c1b9975cad08136d7d1ba0ef15b62de05b18b.jpg',
              permalink: 'jack-daniel-s-single-barrel-select-whiskey-750ml-079f6',
              supplier_id: 410,
              product_id: 207157,
              deals: [],
              two_for_one: null,
              upc: '082184087008',
              overridable: false,
              sku: '11133',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/jack-daniel-s-single-barrel/jack-daniel-s-single-barrel-select-whiskey-750ml-079f6',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: 'Side of the Bottle',
            },
            {
              id: 1951313,
              price: 79.99,
              original_price: 79.99,
              in_stock: 0,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '1L',
              short_pack_size: '',
              short_volume: '1L',
              thumb_url:
                'https://cdn-sandbox.minibardelivery.com/products/251313/small/JDSB_750_FRONT_US_whitejpg.jpg',
              image_url:
                'https://cdn-sandbox.minibardelivery.com/products/251313/product/JDSB_750_FRONT_US_whitejpg.jpg',
              permalink: 'jack-daniel-s-single-barrel-select-whiskey-1l',
              supplier_id: 410,
              product_id: 36389,
              deals: [],
              two_for_one: null,
              upc: '082184148341',
              overridable: false,
              sku: '16479',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/jack-daniel-s-single-barrel/jack-daniel-s-single-barrel-select-whiskey-1l',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: null,
            },
            {
              id: 1951698,
              price: 6.99,
              original_price: 6.99,
              in_stock: 0,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '50ml',
              short_pack_size: '',
              short_volume: '50ml',
              thumb_url:
                'https://cdn-sandbox.minibardelivery.com/products/251313/small/JDSB_750_FRONT_US_whitejpg.jpg',
              image_url:
                'https://cdn-sandbox.minibardelivery.com/products/251313/product/JDSB_750_FRONT_US_whitejpg.jpg',
              permalink: 'jack-daniel-s-single-barrel-select-whiskey-50ml',
              supplier_id: 410,
              product_id: 83011,
              deals: [],
              two_for_one: null,
              upc: '082184787182',
              overridable: false,
              sku: '22236',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/jack-daniel-s-single-barrel/jack-daniel-s-single-barrel-select-whiskey-50ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: null,
            },
          ],
          external_products: [],
          supplier_id: 410,
          deals: [],
          browse_type: 'INTERNAL',
          product_grouping_permalink:
            'https://staging.minibardelivery.com/store/product/jack-daniel-s-single-barrel',
        },
        item_options: null,
        bundle: null,
        product_bundle: {
          id: 's-44658dfc-93b2-4280-80ea-a8a6c318432b',
          title: 'Whiskey Worth Knowing: Premium Spirits Bundle',
          image:
            'http://images.salsify.com/image/upload/s--rFUjfLn8--/ed1d50cae9f070731c4a27c609f6802dc3f1be59.jpg',
          component_product_data: [
            { quantity: 1, product_id: '41110' },
            { quantity: 1, product_id: '28525' },
            { quantity: 1, product_id: '207157' },
            { quantity: 1, product_id: '166020' },
          ],
          external_id: 'BUNDLE-200000041',
        },
        customer_placement: 'standard',
        supplier_name: 'Wine Cellar',
        delivery_method: 'shipped',
        delivery_expectation: 'Usually ships within 1-2 business days',
        engraving_configs: {
          active: true,
          characters: 16,
          lines: 3,
          location: ['Side of the Bottle'],
        },
      },
      {
        identifier: 306101019,
        quantity: 1,
        product: {
          id: 1953227,
          price: 39.99,
          original_price: 39.99,
          in_stock: 12,
          container_type: 'BOTTLE',
          subgroup_id: 'BOTTLE',
          volume: '750ml',
          short_pack_size: '',
          short_volume: '750ml',
          thumb_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
          image_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
          permalink: 'jack-daniel-s-gentleman-jack-tennessee-whiskey-750ml',
          supplier_id: 410,
          product_id: 28525,
          deals: [],
          two_for_one: null,
          upc: '056084000009',
          overridable: false,
          sku: '1580',
          custom_promo: null,
          product_permalink:
            'https://staging.minibardelivery.com/store/product/jack-daniel-s-gentleman-jack/jack-daniel-s-gentleman-jack-tennessee-whiskey-750ml',
          pre_sale_expectation: null,
          weight: null,
          engraving_location: 'Between the Labels',
        },
        product_grouping: {
          id: 38632,
          name: 'The Liquid Magic Elixir Green Finest Town',
          product_name: 'The Liquid Magic Elixir Green Finest Town',
          description:
            "Jack Daniel's Gentleman Jack  is an exceptionally smooth Tennessee whiskey with a rich, rewarding taste and a gentle farewell. The first whiskey in the world mellowed twice for ultimate smoothness.",
          tags: ['whiskey-worth-knowing', 'dad', 'category-feature'],
          type: 'whiskey',
          category: 'liquor',
          brand: "Jack Daniel's",
          hierarchy_category: { permalink: 'liquor', name: 'liquor' },
          hierarchy_type: { permalink: 'liquor-whiskey', name: 'whiskey' },
          hierarchy_subtype: { permalink: 'liquor-whiskey-bourbon', name: 'bourbon' },
          brand_data: { permalink: 'jack-daniel-s', name: "Jack Daniel's" },
          thumb_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
          image_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
          properties: [
            { name: 'Alcohol %', value: '80 Proof' },
            { name: 'Region', value: 'Tennessee' },
            { name: 'Country', value: 'United States' },
            { name: 'Appellation', value: 'Lynchburg Tennessee' },
            { name: 'Varietal', value: 'Other Whiskeys' },
          ],
          permalink: 'jack-daniel-s-gentleman-jack',
          product_content: false,
          variants: [
            {
              id: 1953227,
              price: 39.99,
              original_price: 39.99,
              in_stock: 12,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '750ml',
              short_pack_size: '',
              short_volume: '750ml',
              thumb_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
              image_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
              permalink: 'jack-daniel-s-gentleman-jack-tennessee-whiskey-750ml',
              supplier_id: 410,
              product_id: 28525,
              deals: [],
              two_for_one: null,
              upc: '056084000009',
              overridable: false,
              sku: '1580',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/jack-daniel-s-gentleman-jack/jack-daniel-s-gentleman-jack-tennessee-whiskey-750ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: 'Between the Labels',
            },
            {
              id: 4225052,
              price: 99.99,
              original_price: 99.99,
              in_stock: 0,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '750ml',
              short_pack_size: '',
              short_volume: '750ml',
              thumb_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
              image_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
              permalink: 'jack-daniel-s-gentleman-jack-tennessee-whiskey-750ml',
              supplier_id: 410,
              product_id: 28525,
              deals: [],
              two_for_one: null,
              upc: '056084000009',
              overridable: false,
              sku: '25283',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/jack-daniel-s-gentleman-jack/jack-daniel-s-gentleman-jack-tennessee-whiskey-750ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: 'Between the Labels',
            },
            {
              id: 1948386,
              price: 49.99,
              original_price: 49.99,
              in_stock: 1,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '1L',
              short_pack_size: '',
              short_volume: '1L',
              thumb_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
              image_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-4.png',
              permalink: 'jack-daniel-s-gentleman-jack-tennessee-whiskey-1l',
              supplier_id: 410,
              product_id: 9010,
              deals: [],
              two_for_one: null,
              upc: '082184084045',
              overridable: false,
              sku: '13874',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/jack-daniel-s-gentleman-jack/jack-daniel-s-gentleman-jack-tennessee-whiskey-1l',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: null,
            },
            {
              id: 1955662,
              price: 19.99,
              original_price: 19.99,
              in_stock: 0,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '375ml',
              short_pack_size: '',
              short_volume: '375ml',
              thumb_url:
                'http://images.salsify.com/image/upload/s--uBhCU1e5--/02ede39ae34e657e9346f74209a0910f56382ba0.jpg',
              image_url:
                'http://images.salsify.com/image/upload/s--uBhCU1e5--/02ede39ae34e657e9346f74209a0910f56382ba0.jpg',
              permalink: 'jack-daniel-s-gentleman-jack-tennessee-whiskey-375ml',
              supplier_id: 410,
              product_id: 75711,
              deals: [],
              two_for_one: null,
              upc: '082184083062',
              overridable: false,
              sku: '18287',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/jack-daniel-s-gentleman-jack/jack-daniel-s-gentleman-jack-tennessee-whiskey-375ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: null,
            },
            {
              id: 1949546,
              price: 14.99,
              original_price: 14.99,
              in_stock: 0,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '200ml',
              short_pack_size: '',
              short_volume: '200ml',
              thumb_url:
                'https://cdn-sandbox.minibardelivery.com/products/251299/small/GentlemanJack_375ml_US.jpg',
              image_url:
                'https://cdn-sandbox.minibardelivery.com/products/251299/product/GentlemanJack_375ml_US.jpg',
              permalink: 'jack-daniel-s-gentleman-jack-tennessee-whiskey-200ml',
              supplier_id: 410,
              product_id: 118064,
              deals: [],
              two_for_one: null,
              upc: '082184035016',
              overridable: false,
              sku: '23287',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/jack-daniel-s-gentleman-jack/jack-daniel-s-gentleman-jack-tennessee-whiskey-200ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: null,
            },
            {
              id: 1951087,
              price: 3.99,
              original_price: 3.99,
              in_stock: 0,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '50ml',
              short_pack_size: '',
              short_volume: '50ml',
              thumb_url:
                'https://cdn-sandbox.minibardelivery.com/products/251299/small/GentlemanJack_375ml_US.jpg',
              image_url:
                'https://cdn-sandbox.minibardelivery.com/products/251299/product/GentlemanJack_375ml_US.jpg',
              permalink: 'jack-daniel-s-gentleman-jack-tennessee-whiskey-50ml',
              supplier_id: 410,
              product_id: 78181,
              deals: [],
              two_for_one: null,
              upc: '082184082997',
              overridable: false,
              sku: '21796',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/jack-daniel-s-gentleman-jack/jack-daniel-s-gentleman-jack-tennessee-whiskey-50ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: null,
            },
          ],
          external_products: [],
          supplier_id: 410,
          deals: [],
          browse_type: 'INTERNAL',
          product_grouping_permalink:
            'https://staging.minibardelivery.com/store/product/jack-daniel-s-gentleman-jack',
        },
        item_options: null,
        bundle: null,
        product_bundle: {
          id: 's-44658dfc-93b2-4280-80ea-a8a6c318432b',
          title: 'Whiskey Worth Knowing: Premium Spirits Bundle',
          image:
            'http://images.salsify.com/image/upload/s--rFUjfLn8--/ed1d50cae9f070731c4a27c609f6802dc3f1be59.jpg',
          component_product_data: [
            { quantity: 1, product_id: '41110' },
            { quantity: 1, product_id: '28525' },
            { quantity: 1, product_id: '207157' },
            { quantity: 1, product_id: '166020' },
          ],
          external_id: 'BUNDLE-200000041',
        },
        customer_placement: 'standard',
        supplier_name: 'Wine Cellar',
        delivery_method: 'shipped',
        delivery_expectation: 'Usually ships within 1-2 business days',
        engraving_configs: {
          active: true,
          characters: 16,
          lines: 3,
          location: ['Between the Labels'],
        },
      },
      {
        identifier: 306131800,
        quantity: 1,
        product: {
          id: 1954335,
          price: 44.99,
          original_price: 44.99,
          in_stock: 58,
          container_type: 'BOTTLE',
          subgroup_id: 'BOTTLE',
          volume: '750ml',
          short_pack_size: '',
          short_volume: '750ml',
          thumb_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
          image_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
          permalink: 'woodford-reserve-kentucky-straight-bourbon-whiskey-750ml',
          supplier_id: 410,
          product_id: 41110,
          deals: [],
          two_for_one: null,
          upc: '081128001506',
          overridable: false,
          sku: '13399',
          custom_promo: null,
          product_permalink:
            'https://staging.minibardelivery.com/store/product/woodford-reserve-kentucky-straight-bourbon-whiskey/woodford-reserve-kentucky-straight-bourbon-whiskey-750ml',
          pre_sale_expectation: null,
          weight: null,
          engraving_location: 'Between the Labels',
        },
        product_grouping: {
          id: 42117,
          name: 'The Liquid Magic Elixir Blue Finest in Town',
          product_name: 'The Liquid Magic Elixir Blue Finest in Town',
          description:
            '"Woodford Reserve is built around flavor. \r\n \r\n The art of making fine bourbon first took place on the site of the Woodford Reserve Distillery, a National Historic Landmark, in 1812. The perfectly balanced taste of our Kentucky Straight Bourbon Whiskey is composed of more than 200 detectable flavor notes, from bold grain and wood, to sweet aromatics, spice, and fruit & floral notes."',
          tags: [
            'whiskey-worth-knowing',
            'dad',
            'fall',
            'expert',
            'gift-guide',
            'cocktails',
            'whiskey',
            'category_feature',
            'giftguide',
          ],
          type: 'whiskey',
          category: 'liquor',
          brand: 'Woodford Reserve',
          hierarchy_category: { permalink: 'liquor', name: 'liquor' },
          hierarchy_type: { permalink: 'liquor-whiskey', name: 'whiskey' },
          hierarchy_subtype: { permalink: 'liquor-whiskey-bourbon', name: 'bourbon' },
          brand_data: { permalink: 'woodford-reserve', name: 'Woodford Reserve' },
          thumb_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
          image_url:
            'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
          properties: [
            { name: 'Alcohol %', value: '45.2' },
            { name: 'Region', value: 'Kentucky' },
            { name: 'Country', value: 'United States' },
            { name: 'Varietal', value: 'Bourbon' },
          ],
          permalink: 'woodford-reserve-kentucky-straight-bourbon-whiskey',
          product_content: false,
          variants: [
            {
              id: 2278920,
              price: 49.99,
              original_price: 49.99,
              in_stock: 5,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '750ml',
              short_pack_size: '',
              short_volume: '750ml',
              thumb_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              image_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              permalink: 'woodford-reserve-kentucky-straight-bourbon-whiskey-750ml',
              supplier_id: 410,
              product_id: 41110,
              deals: [],
              two_for_one: null,
              upc: '081128001506',
              overridable: false,
              sku: '24809',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/woodford-reserve-kentucky-straight-bourbon-whiskey/woodford-reserve-kentucky-straight-bourbon-whiskey-750ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: 'Between the Labels',
            },
            {
              id: 1954335,
              price: 44.99,
              original_price: 44.99,
              in_stock: 58,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '750ml',
              short_pack_size: '',
              short_volume: '750ml',
              thumb_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              image_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              permalink: 'woodford-reserve-kentucky-straight-bourbon-whiskey-750ml',
              supplier_id: 410,
              product_id: 41110,
              deals: [],
              two_for_one: null,
              upc: '081128001506',
              overridable: false,
              sku: '13399',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/woodford-reserve-kentucky-straight-bourbon-whiskey/woodford-reserve-kentucky-straight-bourbon-whiskey-750ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: 'Between the Labels',
            },
            {
              id: 1948697,
              price: 24.99,
              original_price: 24.99,
              in_stock: 5,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '375ml',
              short_pack_size: '',
              short_volume: '375ml',
              thumb_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              image_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              permalink: 'woodford-reserve-kentucky-straight-bourbon-whiskey-375ml',
              supplier_id: 410,
              product_id: 17618,
              deals: [],
              two_for_one: null,
              upc: '081128011680',
              overridable: false,
              sku: '18288',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/woodford-reserve-kentucky-straight-bourbon-whiskey/woodford-reserve-kentucky-straight-bourbon-whiskey-375ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: null,
            },
            {
              id: 1953938,
              price: 16.99,
              original_price: 16.99,
              in_stock: 0,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '200ml',
              short_pack_size: '',
              short_volume: '200ml',
              thumb_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              image_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              permalink: 'woodford-reserve-kentucky-straight-bourbon-whiskey-200ml',
              supplier_id: 410,
              product_id: 42997,
              deals: [],
              two_for_one: null,
              upc: '081128031473',
              overridable: false,
              sku: '23905',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/woodford-reserve-kentucky-straight-bourbon-whiskey/woodford-reserve-kentucky-straight-bourbon-whiskey-200ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: null,
            },
            {
              id: 1951501,
              price: 4.99,
              original_price: 4.99,
              in_stock: 47,
              container_type: 'BOTTLE',
              subgroup_id: 'BOTTLE',
              volume: '50ml',
              short_pack_size: '',
              short_volume: '50ml',
              thumb_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              image_url:
                'https://storage.googleapis.com/liquid-platform/assets/liquid_bottle/liquid-bundle-2.png',
              permalink: 'woodford-reserve-kentucky-straight-bourbon-whiskey-50ml',
              supplier_id: 410,
              product_id: 178155,
              deals: [],
              two_for_one: null,
              upc: '081128001551',
              overridable: false,
              sku: '23754',
              custom_promo: null,
              product_permalink:
                'https://staging.minibardelivery.com/store/product/woodford-reserve-kentucky-straight-bourbon-whiskey/woodford-reserve-kentucky-straight-bourbon-whiskey-50ml',
              pre_sale_expectation: null,
              weight: null,
              engraving_location: null,
            },
          ],
          external_products: [],
          supplier_id: 410,
          deals: [],
          browse_type: 'INTERNAL',
          product_grouping_permalink:
            'https://staging.minibardelivery.com/store/product/woodford-reserve-kentucky-straight-bourbon-whiskey',
        },
        item_options: null,
        bundle: null,
        product_bundle: {
          id: 's-44658dfc-93b2-4280-80ea-a8a6c318432b',
          title: 'Whiskey Worth Knowing: Premium Spirits Bundle',
          image:
            'http://images.salsify.com/image/upload/s--rFUjfLn8--/ed1d50cae9f070731c4a27c609f6802dc3f1be59.jpg',
          component_product_data: [
            { quantity: 1, product_id: '41110' },
            { quantity: 1, product_id: '28525' },
            { quantity: 1, product_id: '207157' },
            { quantity: 1, product_id: '166020' },
          ],
          external_id: 'BUNDLE-200000041',
        },
        customer_placement: 'standard',
        supplier_name: 'Wine Cellar',
        delivery_method: 'shipped',
        delivery_expectation: 'Usually ships within 1-2 business days',
        engraving_configs: {
          active: true,
          characters: 16,
          lines: 3,
          location: ['Between the Labels'],
        },
      },
    ],
    bundle: null,
    storefront_cart_id: 'a3849480-2c3c-48a6-bd2d-1ffa63dfd5fa',
  }) as Cart;
  options.body?.cartItems?.forEach((item) => {
    const cartItem = cart.cartItems.find((i) => i.product.id === item.variantId);
    if (cartItem) {
      cartItem.quantity = item.quantity;
      cartItem.itemOptions = item.options;
    }
  });
  return cart;
}

export function cartMock(url: URL, options: any): Cart {
  const rawId = Number(url.pathname.split('/').pop());
  const id = isNaN(rawId) ? Math.floor(Math.random() * (999999 - 90000 + 1) + 90000) : rawId;
  if (id === 123123) {
    return cartMockBundle(id, options);
  }
  return cartMockStandard(id, options);
}
